// src/polaris-components/PaymentMethodDisplay.tsx
import React from 'react';
import { PaymentMethodDetails } from '../types/subscription';
import '../styles/payment-method-display.css';

interface PaymentMethodDisplayProps {
  paymentMethod: PaymentMethodDetails | null;
  onChangeClick?: () => void;
}

export const PaymentMethodDisplay: React.FC<PaymentMethodDisplayProps> = ({
  paymentMethod,
  onChangeClick
}) => {
  if (!paymentMethod) {
    return (
      <div className="payment-method-card" data-testid="payment-method-card">
        <h3>Payment Method</h3>
        <div className="no-payment-method">
          <p className="text-muted">No payment method on file</p>
        </div>
      </div>
    );
  }

  const { last4, brand, expMonth, expYear, billingDetails } = paymentMethod;

  const brandDisplay = brand.charAt(0).toUpperCase() + brand.slice(1);

  const getCardIcon = (cardBrand: string) => {
    const brandLower = cardBrand.toLowerCase();

    switch (brandLower) {
      case 'visa':
        return '💳';
      case 'mastercard':
        return '💳';
      case 'amex':
      case 'american_express':
        return '💳';
      case 'discover':
        return '💳';
      default:
        return '💳';
    }
  };

  const formatExpiry = (month: number, year: number) => {
    const paddedMonth = month.toString().padStart(2, '0');
    return `${paddedMonth}/${year}`;
  };

  return (
    <div className="payment-method-card" data-testid="payment-method-card">
      <div className="payment-method-header">
        <h3>Payment Method</h3>
        {onChangeClick && (
          <button
            onClick={onChangeClick}
            className="change-btn"
            data-testid="change-payment-method-btn"
          >
            Change
          </button>
        )}
      </div>

      <div className="card-info">
        <div className="card-icon" data-testid="card-icon">
          <span className={`card-brand-icon ${brand.toLowerCase()}`}>
            {getCardIcon(brand)}
          </span>
        </div>
        <div className="card-details">
          <p className="card-number" data-testid="card-number">
            {brandDisplay} •••• {last4}
          </p>
          <p className="card-expiry" data-testid="card-expiry">
            Expiry on {formatExpiry(expMonth, expYear)}
          </p>
        </div>
      </div>

      {billingDetails && billingDetails.email && (
        <div className="billing-details">
          <div className="billing-row">
            <span className="billing-email" data-testid="billing-email">
              <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M2 4L8 8L14 4" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                <rect x="2" y="3" width="12" height="10" rx="1" stroke="currentColor" strokeWidth="1.5"/>
              </svg>
              {billingDetails.email}
            </span>
          </div>
        </div>
      )}
    </div>
  );
};

